"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPromoBadge = exports.createMoldovaResidentsBadge = exports.createGalaDinnerBadge = exports.combineTooltipContent = void 0;
var _ramda = require("ramda");
var _localization = _interopRequireDefault(require("../../../../../localization"));
var _Badge = require("../../../../ui/Badge");
var _highPriority = _interopRequireDefault(require("./icons/high-priority.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var createPromoBadge = exports.createPromoBadge = function createPromoBadge(isHeightPromo, promoText) {
  return !!promoText && {
    color: isHeightPromo ? _Badge.COLORS.GREEN : _Badge.COLORS.YELLOW,
    children: '%',
    tooltipContent: promoText
  };
};
var createGalaDinnerBadge = exports.createGalaDinnerBadge = function createGalaDinnerBadge(includesOptions) {
  return (0, _ramda.includes)('gala', includesOptions) && {
    color: _Badge.COLORS.GREEN,
    icon: _highPriority.default,
    tooltipContent: _localization.default.t('TOUR_OPTIONS:GALA_DINNER')
  };
};
var createMoldovaResidentsBadge = exports.createMoldovaResidentsBadge = function createMoldovaResidentsBadge(includesOptions) {
  return (0, _ramda.includes)('moldova', includesOptions) && {
    color: _Badge.COLORS.GREEN,
    icon: _highPriority.default,
    tooltipContent: _localization.default.t('TOUR_OPTIONS:MOLDOVA_RESIDENTS')
  };
};
var combineTooltipContent = exports.combineTooltipContent = function combineTooltipContent() {
  for (var _len = arguments.length, badges = new Array(_len), _key = 0; _key < _len; _key++) {
    badges[_key] = arguments[_key];
  }
  return (0, _ramda.call)((0, _ramda.pipe)((0, _ramda.filter)(Boolean), (0, _ramda.ifElse)(_ramda.isEmpty, (0, _ramda.always)(null), function (filledBadges) {
    var _filledBadges = _toArray(filledBadges),
      coreBadge = _filledBadges[0],
      restBadges = _filledBadges.slice(1);
    return (0, _ramda.over)((0, _ramda.lensProp)('tooltipContent'), function (originalTooltipContent) {
      return (0, _ramda.join)(', ', [originalTooltipContent].concat(_toConsumableArray((0, _ramda.map)((0, _ramda.prop)('tooltipContent'), restBadges))));
    }, coreBadge);
  })), badges);
};